module.exports = __webpack_public_path__ + "img/closeMark-light01.e6b7fd2e.png";